import { useGlobal } from "@/app/store/global"

export const useTheme = () => {
  const isDark = useGlobal(state => state.isDarkTheme)
  const toggleTheme = useGlobal.changeTheme

  return { isDark, toggleTheme }
}
